import { Autocomplete, TextField } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { calculateLocatinVars } from '../../../libs/browser';
import { confirmEmailValidator, emailValidator, emptyValidator } from '../../../libs/valid-rule';
import { getEditProfileForm, getLanguage, profileRecord, telOptions } from '../../../libs/formData';
import { getGrecaptchaToken } from '../../../libs/state';
import { getLanguageList } from '../../../libs/date';
import { parseError } from '../../../libs/parser';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BackCloseBarComponent from '../../../components/BackCloseBarComponent';
import CommonIconButton from '../../../components/CommonIconButton';
import Context from '../../../provider';
import ErrorMsgComponent from '../../../components/ErrorMsgComponent';
import IconBenefitsRed from '../../../assets/hkdc/icons/BenefitsRedIcon';
import IconEmail from '../../../assets/hkdc/icons/EmailIcon';
import IconSettingTag from '../../../assets/hkdc/icons/SettingTagIcon';
import InputComponent from '../../../components/InputComponent';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import NativeSelect from '@mui/material/NativeSelect';
import React, { useContext, useEffect, useRef, useState } from 'react';
import ToggleGroupComponent from '../../../components/ToggleGroupComponent';
import config from '../../../config';
import memberApi from '../../../libs/api/memberApi';
import useIsScrolling from '../../../hooks/useIsScrolling';
import useNotificationsCount from '../../../hooks/useNotificationsCount';
import * as dayjs from 'dayjs';
import './index.scss';

export default function MobileEditProfile() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const locationVars = calculateLocatinVars(location.pathname);

  const notificationNotReadCount = useNotificationsCount();

  const scrollRef = useRef();
  const isScrolling = useIsScrolling(scrollRef.current);

  const { init, me, dispatch, appConfig } = useContext(Context);

  const [errorMsg, setError] = useState(false);
  // 联系方式
  const [mobileCountryCode, setMobileCountryCode] = useState('+852');
  const [profileForm, setProfileForm] = useState([]);
  const [titleOptions, setTitleOptions] = useState([]);
  const [profileData, setProfileData] = useState(null);
  const [contactNum, setContactNum] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');

  const [pageInit, setPageInit] = useState(false);
  const [activeEditProfileNext, setActiveEditProfileNext] = React.useState(false);

  const [newEmail, setNewEmail] = useState('');
  const [confirmNewEmail, setConfirmNewEmail] = useState('');

  useEffect(() => {
    const titleOptions = [
      { label: t('registration.prof'), data: 'prof' },
      { label: t('registration.dr'), data: 'dr' },
      { label: t('registration.mr'), data: 'mr' },
      { label: t('registration.ms'), data: 'ms' },
      { label: t('registration.mrs'), data: 'mrs' }
    ];

    setTitleOptions(titleOptions);
  }, []);

  useEffect(() => {
    if (profileData) {
      if (profileForm.length > 0) {
        const isRequest = profileForm.every((item) => {
          if (item.isRequest) {
            return !!profileData[item.id];
          } else {
            return true;
          }
        });

        setActiveEditProfileNext(isRequest);
      }
    } else {
      setActiveEditProfileNext(false);
    }
  }, [profileData]);

  // This page only allow logged in user
  useEffect(() => {
    if (init) {
      if (locationVars[1] === "profile") {
        setProfileForm(getEditProfileForm());
        setProfileData(profileRecord);

        if (me) {

          initProfileData(profileRecord);
        }

      }
    }
  }, [init, me, navigate]);

  useEffect(() => {
    if (pageInit) {
      setProfileData({ ...profileData, mobile: mobileCountryCode + ' ' + contactNum });
    }
  }, [mobileCountryCode, contactNum]);

  useEffect(() => {
    if (errorMsg && errorMsg !== '') {
      let timer = null;
      timer = setTimeout(() => {
        setError('');
        clearTimeout(timer);
      }, 2000);
    }
  }, [errorMsg]);

  const updateAccount = async (e) => {
    e.preventDefault();

    try {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: true });
      const response = await memberApi.updateLoyaltyAccount(
        profileData
      );
      if (response) {
        // update `me` in provider
        dispatch({ type: 'SET_ME', payload: { ...me, loyalty_account: { ...me.loyalty_account, ...profileData } } });
        // Go back to previous page
        navigate(`${config.basename}success`, {
          replace: true,
          state: {
            title: 'success.profile-tile',
            desc: 'success.profile-desc'
          }
        });

      }
    } catch (error) {
      setError(parseError(error).message);
    } finally {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: false });
    }
  };

  const updateIdentity = async () => {
    try {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: true });
      const result = await memberApi.requestUpdateIdentity({
        email: newEmail
      });

      navigate(`${config.basename}email-otp`, {
        replace: true,
        state: {
          type: locationVars[1],
          username: newEmail,
          token: result.token
        }
      });
      // setUpdateIdentityData({ ...data, token: result.token });
    } catch (error) {
      setError(parseError(error).message);
    } finally {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: false });
    }
  };

  const initProfileData = (form) => {
    Object.keys(form).map((key) => {
      if (me.loyalty_account[key]) {
        form[key] = me.loyalty_account[key];
      }
      return null;
    });

    setProfileData({ ...profileData, ...form });
    setPageInit(true);
  };

  const languageChange = (value) => {
    if (!pageInit) return;
    let language = 'en';
    if (value !== 'en') {
      language = value === 'tc' ? 'zh-HK' : 'zh-CN';
    }
    setProfileData({ ...profileData, preference_language: language });
  };

  const changeSubmit = async () => {
    try {
      if (locationVars[1] === "forgot-email") {
        dispatch({ type: 'SET_BACKDROP_LOADING', payload: true });
        const email = await memberApi.checkForgotEmail({
          countryCode: mobileCountryCode,
          mobile: contactNum,
          first_name: firstName,
          last_name: lastName
        });

        const data = {
          countryCode: undefined,
          mobile: undefined,
          email: email
        };
        const loginData = { ...data, username: data.email };

        sendOtp(loginData);
      }
    } catch (error) {
      setError(parseError(error).message);
    } finally {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: false });
    }

  };

  const sendOtp = async (loginData) => {
    try {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: true });
      await memberApi.requestOtp({
        ...loginData,
        ...(appConfig?.recaptcha ? { gRecaptchaResponse: await getGrecaptchaToken(appConfig?.recaptcha) } : {})
      });

      navigate(`${config.basename}email-otp`, {
        replace: true,
        state: {
          type: 'forgot-email',
          username: loginData.email
        }
      });
    } catch (error) {
      dispatch({
        type: 'SET_ERROR_DIALOG',
        payload: { open: true, ...parseError(error) }
      });
    } finally {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: false });
    }
  };

  const handleButtonDisabled = () => {
    if (locationVars[1] === "forgot-email") {
      return lastName === '' || lastName === '' || contactNum === '';
    } else if (locationVars[1] === "email-edit") {
      return newEmail === '' || confirmNewEmail === '' || newEmail !== confirmNewEmail;
    }
  };

  return (
    (
      <div className='mobile-edit-profile-page'>
        <BackCloseBarComponent />
        <div ref={scrollRef} className="content-container">
          <div className="setting-title-container">
              <div className="title-text-cont">
                <div className="title-text">
                  {
                    locationVars[1] === "profile" ? `${t('profile.edit-title')}` : locationVars[1] === "email-edit" ? `${t('change-email.page-title')}` : `${t('forgot-page.title')}`
                  }
                </div>
              </div>
              <IconSettingTag
                className="setting-tag-icon"
                size="large" />
          </div>
          {locationVars.length >= 2 && locationVars[1] === "profile" &&
            <div className="setting-content-container">
              <div className="setting-title-time">
                  <div className="icon-container">
                    <IconBenefitsRed
                      className="icon"
                      size="large" />
                  </div>
                  <div className="title-text">
                    {t('common.personal-info')}
                  </div>
              </div>
              <div className="form-group">
                {profileForm && profileForm.length > 0 &&
                    profileForm.map((formItem, index) => {
                      switch (formItem.type) {
                        case 'select':
                          return (
                            <Autocomplete
                              key={index}
                              fullWidth
                              value={titleOptions.find((item) => item.data === profileData[formItem.id])}
                              label={t(formItem.label)}
                              id="combo-box-demo"
                              options={titleOptions}
                              getOptionLabel={(option) => option.label}
                              onChange={(e, value) => {
                                e.stopPropagation();
                                if (value && value.data) {
                                  setProfileData({ ...profileData, [formItem.id]: value.data });
                                } else {
                                  setProfileData({ ...profileData, [formItem.id]: "" });
                                }
                              }}
                              renderInput={(params) => <TextField {...params} variant="standard" label={t(formItem.label)} />}
                            />);
                        case 'input':
                          return (
                            <InputComponent
                              key={index}
                              onValueChange={(value) => {
                                setProfileData({ ...profileData, [formItem.id]: value });
                              }}
                              defaultValue={profileData[formItem.id]}
                              validator={emptyValidator}
                              customerError={t(formItem.label)}
                              label={t(formItem.label)}
                              fullWidth={true}
                            />);
                        case 'date':
                          // console.log(formItem);
                          const now =dayjs();
                          let defaultValue = null;
                          if (profileData.birth_month && profileData.birth_day) {
                            defaultValue = now.set('mouth', profileData.birth_month).set('day', profileData.birth_day);
                          }

                          return (
                            <DesktopDatePicker
                              minDate={formItem.min}
                              maxDate={formItem.max}
                              defaultValue={defaultValue}
                              views={formItem.views}
                              label={t(formItem.label)}
                              key={index}
                              format={formItem.format}
                              onChange={(value) => {
                                const month = value.get('month') + 1;
                                const day = value.get('date');
                                const dob = {
                                  birth_month: month,
                                  birth_day: day
                                };
                                setProfileData({ ...profileData, ...dob });
                              }}
                              slotProps={{
                                textField: {
                                  error: profileData.birth_month && profileData.birth_day ? false :true,
                                  variant: 'standard',
                                  fullWidth: true
                                },
                                layout: {
                                  sx: {
                                    '.MuiPickersCalendarHeader-root': formItem.id === 'dob' ? {
                                      visibility: 'hidden'
                                    }: undefined
                                  }
                                }
                              }}
                            />
                          );
                        case 'tel':
                          let country_code = mobileCountryCode;
                          let contact_num = '';
                          if (me.mobile) {
                            const tels = me.mobile.split(' ');
                            country_code = tels[0];
                            contact_num = tels[1];
                          }

                          return (
                            <div key={index} className="tel-form-group">
                              <NativeSelect
                                name="country_code"
                                defaultValue={ country_code }
                                disableUnderline={true}
                                onChange={(e) => {
                                  e.stopPropagation();
                                  setMobileCountryCode(e.target.value);
                                }}
                              >
                                {telOptions.map((code) => {
                                  return (<option key={code} value={code}>{code}</option>);
                                })}
                              </NativeSelect>
                              <InputComponent
                                onValueChange={(value) => {
                                  setContactNum(value);
                                }}
                                defaultValue={contact_num}
                                label={t(formItem.label)}
                                fullWidth={true}
                              />
                            </div>
                          );
                        case 'language':
                          return (
                            <div key={index} className="language-form-item-cont">
                              <div className="title-content-cont">
                                <div className="title-text">
                                  {t(formItem.label)}
                                </div>
                                <div className="content-text">
                                  {t(formItem.desc)}
                                </div>
                              </div>
                              <ToggleGroupComponent
                                isChange={false}
                                defaultValue={getLanguage(profileData[formItem.id])}
                                groupList={getLanguageList()}
                                onChange={languageChange}
                              />
                            </div>
                          );
                        case 'email':
                          return (
                            <div key={index} className="email-form-item-cont">
                              <div className="title-content-cont">
                                <div className="title-text">
                                  {t(formItem.label)}
                                </div>
                                <div className="content-text">
                                  {me.email}
                                </div>
                              </div>
                              <div className='change-email-btn' onClick={() => {
                                navigate('/setting/email-edit');
                              }} >
                                <div className='btn-text'>
                                  {t('edit-profile.change-email-btn')}
                                </div>
                                <div className="icon-cont">
                                  <IconEmail
                                    className="icon"
                                    size="large" />
                                </div>
                              </div>
                            </div>
                          );
                        default:
                          return null;
                      }
                    })
                  }
                  {errorMsg && <ErrorMsgComponent msgInfo={errorMsg} />}
              </div>
              <CommonIconButton
                  text={t('edit-profile.btn')}
                  disabled={!activeEditProfileNext}
                  btnBackgroundColor= {!activeEditProfileNext ? '#C6C6C5' : '#004899'}
                  btnColor = "#ffffff"
                  btnWidth= "11.625rem"
                  btnHeight= "2.375rem"
                  onClick={updateAccount}
                />
            </div>
          }

          {locationVars.length >= 2 && locationVars[1] === "email-edit" &&
            <div className="setting-content-container">
                <div className="setting-title-time">
                  <div className="icon-container">
                    <IconBenefitsRed
                      className="icon"
                      size="large" />
                  </div>
                  <div className="title-text">
                    {t('change-email.title')}
                  </div>
                </div>
                <div className="form-group">
                  <InputComponent
                    onValueChange={(value) => {
                      setNewEmail(value);
                    }}
                    label={t('change-email.new')}
                    customerError={t('change-email.new')}
                    fullWidth={true}
                    errorValue={''}
                    errorCondition={() => false}
                    validator={emailValidator}
                  />
                  <InputComponent
                    onValueChange={(value) => {
                      setConfirmNewEmail(value);
                    }}
                    label={t('change-email.confirm')}
                    customerError={t('change-email.confirm')}
                    fullWidth={true}
                    errorValue={''}
                    errorCondition={() => false}
                    validator={confirmEmailValidator(newEmail, t('change-email.email-match'))}
                  />
                  {errorMsg && <ErrorMsgComponent msgInfo={errorMsg} />}
                </div>
                <CommonIconButton
                  text={t('change-email.submit')}
                  disabled={handleButtonDisabled()}
                  btnBackgroundColor= {handleButtonDisabled() ? '#C6C6C5' : '#004899'}
                  btnColor = "#ffffff"
                  btnWidth= "7.1875rem"
                  btnHeight= "2.375rem"
                  onClick={(e) => {
                    e.stopPropagation();
                    updateIdentity();
                  }}
                />
            </div>
          }

          {locationVars.length >= 2 && locationVars[1] === "forgot-email" &&
            <div className="setting-content-container">
                <div className="setting-title-time">
                  <div className="icon-container">
                    <IconBenefitsRed
                      className="icon"
                      size="large" />
                  </div>
                  <div className="title-text">
                    {t('common.personal-info')}
                  </div>
                </div>
                <div className="form-group">
                  <InputComponent
                    onValueChange={(value) => {
                      setFirstName(value);
                    }}
                    errorCondition={() => false}
                    validator={emptyValidator}
                    customerError={t('common.first-name')}
                    label={t('common.first-name')}
                    fullWidth={true}
                  />
                  <InputComponent
                    onValueChange={(value) => {
                      setLastName(value);
                    }}
                    errorCondition={() => false}
                    validator={emptyValidator}
                    customerError={t('common.last-name')}
                    label={t('common.last-name')}
                    fullWidth={true}
                  />
                  <div className="tel-form-group">
                    <NativeSelect
                      name="country_code"
                      defaultValue={ mobileCountryCode }
                      disableUnderline={true}
                      onChange={(e) => {
                        e.stopPropagation();
                        setMobileCountryCode(e.target.value);
                      }}
                    >
                      {telOptions.map((code) => {
                        return (<option key={code} value={code}>{code}</option>);
                      })}
                    </NativeSelect>
                    <InputComponent
                      onValueChange={(value) => {
                        setContactNum(value);
                      }}
                      label={t('common.contact-no')}
                      errorCondition={() => false}
                      fullWidth={true}
                      />
                  </div>
                  {errorMsg && <ErrorMsgComponent msgInfo={errorMsg} />}
                </div>
                <CommonIconButton
                  text={t('common.next-btn')}
                  endIcon= {<KeyboardArrowRightIcon />}
                  disabled={handleButtonDisabled()}
                  btnBackgroundColor= {handleButtonDisabled() ? '#C6C6C5' : '#004899'}
                  btnColor = "#ffffff"
                  btnWidth= "8.625rem"
                  btnHeight= "2.375rem"
                  onClick={(e) => {
                    e.stopPropagation();
                    changeSubmit("email");
                  }}
                />
            </div>
          }
        </div>
      </div>
    )
  );
}